import React from 'react';
import {
    Image,
    View,
    Text,
    Linking,
    StyleSheet,
    ScrollView,
    ImageBackground,
    TouchableOpacity,
    ToastAndroid,
    ActivityIndicator
} from 'react-native';

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../../components/StyledButton';
import GenericModal from '../../components/modals/GenericModal';
import StyledIcon from '../../components/StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation, useRoute } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import WalletNavCard from '../../components/wallet/NavCard';
import WalletHistoryCard from '../../components/wallet/HistoryCard';
import GenericHeader from '../../components/headers/GenericHeader';
import http from '../../utils/http';

const analytics = new AnalyticsService

function WalletIndexScreen() {
    // let canRedirect = false
    const navigation = useNavigation()
    const route = useRoute()

    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [isLoading, setLoading] = React.useState(true)
    const [hasError, setError] = React.useState(false)

    const [hasEyowoAccount, setEyowoAccount] = React.useState(false)
    const [createWalletModalState, setCreateWalletModalState] = React.useState(false)
    const [linkWalletModalState, setLinkWalletModalState] = React.useState(false)

    const [acceptCreate, setAcceptCreate] = React.useState(false)
    const [acceptLink, setAcceptLink] = React.useState(false)

    const [creating, setCreating] = React.useState(false)
    const [linking, setLinking] = React.useState(false)

    const toggleAcceptCreate = () => setAcceptCreate(!acceptCreate)
    const toggleAcceptLink = () => setAcceptLink(!acceptLink)

    const hideCreateWalletModal = () => {
        setAcceptCreate(false)
        setCreateWalletModalState(false)
    }
    const hideLinkWalletModal = () => {
        setAcceptLink(false)
        setLinkWalletModalState(false)
    }

    const createWallet = () => {
        setLoading(true)
        hideCreateWalletModal()
        let form = new FormData()
        form.append('mobile', buyer.phone)
        form.append('model', 'buyer')
        http.post('spend/eyowo_user_create', form, token)
            .then(res => {
                if (res.code === 200) {
                    readWallet()
                } else {
                    setCreateWalletModalState(true)
                    acceptCreate(false)
                    setLoading(false)
                    // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                }
            })
            .catch(err => {
                setLoading(false)
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            })
    }

    const readWallet = () => {
        setLoading(true)
        setError(false)
        let form = new FormData()
        form.append('mobile', buyer.phone)
        http.post('spend/eyowo_user_validate', form, token)
            .then(res => {
                if (res.code === 200) {
                    // user has eyowo account wallet

                    // if (canRedirect) {
                    //     navigation.navigate('WalletPasscode')
                    //     return
                    // }
                    // console.log(route.name)
                    // isLoading(false)
                    // return

                    // check for first time usage
                    form.append('model', 'buyer')
                    http.post('spend/eyowo_user_authenticate', form, token)
                        .then(res => {
                            // this is first time
                            // {
                            //     "code": 200,
                            //     "message": "",
                            //     "data": {
                            //         "success": true,
                            //         "message": "Please enter the passcode sent to 2347035062878"
                            //     }
                            // }

                            // this is not first time
                            // {
                            //     "code": 200,
                            //     "message": "",
                            //     "data": {
                            //         "success": true,
                            //         "data": {
                            //             "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmLgjH2m5c8emE66pjdExmgep47BAdKTrsso2Vu8Ke6GEY5W51wwPPMqKZJowXQCeaFNYwYXQiOjE1OTc0MjE5ODcsImV4cCI6MTU5NzUwODM4N30.4pFcLgjH2m5c8emE66pjdExmgep47BAdKTrCJ7i68RI",
                            //             "expiresIn": 86400
                            //         }
                            //     }
                            // }

                            if (res.code === 200 && res?.data?.success) {
                                if (res?.data?.data?.accessToken) {
                                    setEyowoAccount(true)
                                    setLoading(false)
                                    // not new - re-authenticate
                                } else {
                                    navigation.navigate('WalletPasscode')
                                }
                            } else {
                                setError(true)
                                setLoading(false)
                                // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                            }

                        })
                        .catch(err => {
                            setError(true)
                            setLoading(false)
                            // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                        })
                } else {
                    // user does not have a wallet
                    setEyowoAccount(false)
                    setLoading(false)
                    // // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                }
            })
            .catch(err => {
                setError(true)
                setLoading(false)
            })
    }

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            if (route.name === 'WalletIndex') {
                readWallet()
                analytics.logEvent('Viewed Wallet Home', buyer)
                analytics.googleHelpers.setCurrentScreen('ViewedWalletHome', 'ViewedWalletHome')
            }
        })

        return () => {
            // cleanup
            navigation.removeListener('focus')
        };
    }, []);

    return (
        <>
            <GenericHeader title="My Wallet" />
            {isLoading
                ? <View style={{ flex: 1, justifyContent: 'center' }}>
                    <ActivityIndicator size={50} color={Colors.tintColor} style={{ alignSelf: 'center' }} />
                </View>
                : hasError
                    ? <View style={styles.container}>

                        <View style={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center', padding: 16 }}>
                            <StyledIcon iconName="md-alert" iconOnly iconColor={Colors.greyColor} size={50} />

                            <Text style={[styles.message, FontStyles.normal, FontStyles.size14, FontStyles.lh20]}>Unable to load data.</Text>

                            <StyledButton label="Try Again" size="sm" style={{ marginTop: 56 }} action={() => readWallet()} />

                        </View>
                    </View>
                    : hasEyowoAccount
                        ? <ScrollView contentContainerStyle={[styles.container, {paddingBottom: 16}]}>
                            <WalletNavCard />
                            <WalletHistoryCard />
                        </ScrollView>
                        : <ScrollView contentContainerStyle={styles.container}>
                            <GenericModal
                                modalState={createWalletModalState}
                                hideModal={hideCreateWalletModal}
                                icon={<ImageBackground source={require('../../assets/images/main/suplias-eyowo-link.png')} style={{ width: 120, height: undefined, aspectRatio: 106.53 / 34.9, marginTop: 28 }} resizeMode="contain" />}
                                content={<View style={{ alignItems: 'center' }}>
                                    <Text style={[
                                        styles.createText,
                                        FontStyles.normal,
                                        FontStyles.size14,
                                        FontStyles.lh20,
                                        FontStyles.dark,
                                        {
                                            textAlign: 'center',
                                            width: 214,
                                            marginTop: 30
                                        }]}>Your Suplias wallet creates an Eyowo account. You would receive SMS alerts from the Eyowo account as you use the Suplias wallet.</Text>
                                    <View style={{ flexDirection: 'row', marginTop: 20 }}>
                                        <TouchableOpacity style={{ flexDirection: 'row' }} activeOpacity={1} onPress={toggleAcceptCreate}>
                                            {acceptCreate
                                                ? <StyledIcon iconName="md-checkmark" size={16} square fillColor={Colors.successBackground} iconColor={Colors.successText} style={{ alignSelf: 'center' }} />
                                                : <StyledIcon size={16} square fillColor={Colors.shades._5} iconColor={Colors.successText} outlineColor={Colors.shades._1} style={{ alignSelf: 'center' }} />
                                            }
                                            <Text style={[FontStyles.size14, FontStyles.lh20, FontStyles.gray, { marginLeft: 6 }]}>I accept </Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity>
                                            <Text style={[FontStyles.size14, FontStyles.lh20, { color: Colors.tintColor }]}>terms & conditions</Text>
                                        </TouchableOpacity>
                                    </View>
                                    <StyledButton label="Continue" size="sm" disabled={!acceptCreate} action={createWallet} style={{ marginTop: 30 }} />
                                    <StyledButton label="Learn More" size="sm" color="light" style={{ marginTop: 10, marginBottom: 16 }} />
                                </View>}
                            />
                            <GenericModal
                                modalState={linkWalletModalState}
                                hideModal={hideLinkWalletModal}
                                icon={<ImageBackground source={require('../../assets/images/main/suplias-eyowo-link.png')} style={{ width: 120, height: undefined, aspectRatio: 106.53 / 34.9, marginTop: 28 }} resizeMode="contain" />}
                                content={<View style={{ alignItems: 'center' }}>
                                    <Text style={[
                                        styles.createText,
                                        FontStyles.normal,
                                        FontStyles.size14,
                                        FontStyles.lh20,
                                        FontStyles.dark,
                                        {
                                            textAlign: 'center',
                                            width: 214,
                                            marginTop: 30
                                        }]}>Your Suplias wallet will be linked to your existing Eyowo account. You would receive SMS alerts from the Eyowo account as you use the Suplias wallet.</Text>
                                    <View style={{ flexDirection: 'row', marginTop: 20 }}>
                                        <TouchableOpacity style={{ flexDirection: 'row' }} activeOpacity={1} onPress={toggleAcceptLink}>
                                            {acceptLink
                                                ? <StyledIcon iconName="md-checkmark" size={16} square fillColor={Colors.successBackground} iconColor={Colors.successText} style={{ alignSelf: 'center' }} />
                                                : <StyledIcon size={16} square fillColor={Colors.shades._5} iconColor={Colors.successText} outlineColor={Colors.shades._1} style={{ alignSelf: 'center' }} />
                                            }
                                            <Text style={[FontStyles.size14, FontStyles.lh20, FontStyles.gray, { marginLeft: 6 }]}>I accept </Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity>
                                            <Text style={[FontStyles.size14, FontStyles.lh20, { color: Colors.tintColor }]}>terms & conditions</Text>
                                        </TouchableOpacity>
                                    </View>
                                    <StyledButton label="Authorize Suplias" size="sm" disabled={!acceptLink} style={{ marginTop: 30 }} />
                                    <StyledButton label="Learn More" size="sm" color="light" style={{ marginTop: 10, marginBottom: 16 }} />
                                </View>}
                            />
                            <View style={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center', padding: 16 }}>
                                <Image source={require('../../assets/images/main/wallet-illustration.png')} style={{ aspectRatio: 103 / 86, width: 120, height: undefined, marginBottom: 18 }} />

                                <Text style={[styles.message, FontStyles.normal, FontStyles.size14, FontStyles.lh20]}>Suplias wallet lets you do something, do another thing, then one last thing</Text>

                                <StyledButton label="Get Started" size="sm" style={{ marginTop: 56 }} action={() => setCreateWalletModalState(true)} />
                                {/* {!hasEyowoAccount
                                ? <StyledButton label="Get Started" size="sm" style={{ marginTop: 56 }} action={() => setCreateWalletModalState(true)} />
                                : <StyledButton label="Get Started" size="sm" style={{ marginTop: 56 }} action={() => setLinkWalletModalState(true)} />
                            } */}

                            </View>
                        </ScrollView>
            }
        </>
    )
}

export default WalletIndexScreen

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.shades._5,
    },
    message: {
        width: 214,
        color: Colors.darkTextColor,
        textAlign: 'center',
        marginTop: 7
    }
})